import { Perencanaan } from 'app/KinerjaGpkPage/pages/tim-kinerja/perencanaan/Perencanaan'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardGpkTimKinerja } from 'app/KinerjaGpkPage/components/PageGuardGpkTimKinerja'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { GetServerSidePropsResult, NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ): Promise<GetServerSidePropsResult<{}>> => {
    const isKinerjaGpkEnabled = toggle?.['kinerja-gpk-enabled'] || false

    if (!isKinerjaGpkEnabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

export default function Page() {
  return (
    <PageGuardGpkTimKinerja>
      <Perencanaan />
    </PageGuardGpkTimKinerja>
  )
}

Page.Layout = KinerjaLayout
